<div [class]="classes?.lineWrapper">
    <div *ngIf="isSafari && (widget.styles.borderTopStyle === 'dotted'); else defaultLine" [class]="classes.lineSafari">
    </div>

    <ng-template #defaultLine>
        <hr class="sp-line" [class]="classes?.line">
    </ng-template>
</div>
